// extracted by mini-css-extract-plugin
export default {"headline":"_2FjlFRhLma682grP5O1imV"};